import { SystemStyleObject } from '@chakra-ui/react';

export const wrapperSx: SystemStyleObject = {
  position: 'relative',
  borderColor: 'gray.900',
  rounded: 'xl',
  px: [6, 7, 8],
  pt: [4, 6, 6, 8],
  pb: [12, 14, 14, 16],
};

export const headingSx: SystemStyleObject = {
  fontWeight: 'normal',
  textTransform: 'capitalize',
  mb: 2,
};

export const badgeSx: SystemStyleObject = {
  bg: 'gray.900',
  position: 'absolute',
  rounded: 'lg',
  top: '-2px',
  right: '-2px',
  color: 'white',
  px: 5,
  py: 2,
  fontWeight: 'semibold',
  textTransform: 'none',
  borderTopLeftRadius: 0,
  borderBottomRightRadius: 0,
};

export const priceSx: SystemStyleObject = {
  fontSize: ['4xl', '5xl', '2.8rem'],
  fontWeight: 'extrabold',
  mb: 4,
  /* ':first-letter': {
    fontSize: '3xl',
    verticalAlign: 'top',
    lineHeight: 1.8,
    letterSpacing: 3,
  }, */
};

export const subtextSx: SystemStyleObject = {
  fontSize: 'sm',
  mb: 8,
  minH: 46,
};
